import BlogCard from './BlogCard';
import classes from './BlogCardList.module.css';

const BlogCardList = (props) => {
  let blogCardList = null;

  if (props.blogList) {
    blogCardList = props.blogList.map((blog) => (
      <BlogCard key={blog.id} blog={blog} />
    ));
  }

  return <div className={classes['card-list']}>{blogCardList}</div>;
};

export default BlogCardList;
